var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSuccessMotivation = function SvgIconSuccessMotivation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4,
    r: 3.5,
    stroke: "#1D1D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m2.833 3.909 1.172 1.172 2.162-2.162",
    stroke: "#1D1D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgIconSuccessMotivation as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOSA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC41IDRDMC41IDEuNzkwODYgMi4yOTA4NiAwIDQuNSAwQzYuNzA5MTQgMCA4LjUgMS43OTA4NiA4LjUgNEM4LjUgNi4yMDkxNCA2LjcwOTE0IDggNC41IDhDMi4yOTA4NiA4IDAuNSA2LjIwOTE0IDAuNSA0WiIgZmlsbD0id2hpdGUiLz4KPGNpcmNsZSBjeD0iNC41IiBjeT0iNCIgcj0iMy41IiBzdHJva2U9IiMxRDFEMUQiLz4KPHBhdGggZD0iTTIuODMzNSAzLjkwOTA0TDQuMDA1MjcgNS4wODA4MUw2LjE2NjgzIDIuOTE5MTYiIHN0cm9rZT0iIzFEMUQxRCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";